import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-6 px-4 border-t border-gray-100" data-id="element-69">
      <div className="max-w-3xl mx-auto text-center" data-id="element-70">
        <div className="flex justify-center mb-3" data-id="element-71">
          <ShieldCheck className="w-16 h-16 text-green-600" strokeWidth={1.5} data-id="element-72" />
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-73">
          Garantía de Satisfacción Total
        </h2>

        <p className="text-lg text-gray-600 leading-relaxed" data-id="element-74">
          Probalo 7 días. Si no cumple tus expectativas, te devolvemos el 100%.{' '}
          <br data-id="element-75" />
          <span className="font-bold text-gray-900" data-id="element-76">Sin preguntas.</span>
        </p>
      </div>
    </section>;
}